import React from 'react';

import CountryInfo from '../CountryInfo';

const BUSINESS_SECTION = {
    title: '£320M Package for Businesses',
    content: (
        <div>
            <p className="eds-text-bl eds-l-mar-bot-4">Details</p>
            <ul>
                <li>
                    75% rates relief for retail, hospitality and leisure sectors
                    with a rateable value of less than £69,000 from 1 April 2020
                </li>
                <li>
                    £80 million fund to provide grants of at least £3,000 to
                    small businesses in sectors facing the worst economic impact
                    of COVID-19
                </li>
                <li>
                    1.6% rates relief for all properties across Scotland,
                    effectively reversing the planned below inflation uplift in
                    the poundage from 1 April 2020
                </li>
                <li>
                    Fixed rates relief of up to £5,000 for all pubs with a
                    rateable value of less than £100,000 from 1 April 2020
                </li>
                <li>£10,000 grant for small and rural businesses</li>
                <li>
                    12-month relief for properties in hospitality, leisure and
                    £25,000 grant at a rateable value between £18,000 and
                    £51,000
                </li>
                <li>
                    Business helpline number is 0300 303 0660 (select option
                    one). The helpline will be open Monday to Friday 8.30am to
                    5.30pm.
                </li>
            </ul>
        </div>
    ),
    links: [
        {
            title: '£320 million package of support for businesses',
            url: 'https://www.gov.scot/news/gbp-320-million-package-of-support-for-businesses/',
        },
    ],
};

const BANK_SECTION = {
    title: 'Royal Bank of Scotland (RBS) Response',
    content: <p>Defer mortgage and loan repayments for up to three months.</p>,
    links: [
        {
            title: 'Coronavirus: Banks to allow customers to defer mortgage payments',
            url: 'https://www.bbc.com/news/business-51817947',
        },
    ],
};
const COUNTRY_INFO = {
    countryName: 'Scotland',
    lastUpdated: 'March 21, 2020',
    introSection: (
        <p>
            Scotland has multiple different financial assistance options
            available. Please look over this information and follow up as
            appropriate.
        </p>
    ),
    sections: [BUSINESS_SECTION, BANK_SECTION],
};

const ScotlandInfo = () => <CountryInfo info={COUNTRY_INFO} />;

export default ScotlandInfo;
